import { render, staticRenderFns } from "./ship-cargo.svg.vue?vue&type=template&id=5d67bf12&"
import script from "./ship-cargo.svg.vue?vue&type=script&lang=js&"
export * from "./ship-cargo.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports